import { SearchWorkflowTasksResponse } from "../../service/query";

export type PanelTask = SearchWorkflowTasksResponse["results"][0];

// Workflow tasks hang off a workflow step; general tasks are standalone (no step).
export type TaskPanelTaskType = "general" | "workflow";

/*
  What the overlay is doing, as one value rather than the several booleans it used to be derived into
  (`task === undefined`, `isGeneralTask`, `isCreateTask`). The two states carry different data — only an
  edit has a task, with its uuid, rowVersion and stored relations — so narrowing on `kind` gives the edit
  paths a non-optional task and makes "create with a task" unrepresentable.
*/
export type TaskPanelMode =
  | { kind: "create"; taskType: TaskPanelTaskType }
  | { kind: "edit"; task: PanelTask; taskType: TaskPanelTaskType };

/*
  On edit the type is a fact about the task (a general task has no step, KAN-9500); on create it is the
  choice the host passed in (REQ-010), since there is no task to read it from yet.
*/
export const resolveTaskPanelMode = (task: PanelTask | undefined, isGeneralTask: boolean | undefined): TaskPanelMode =>
  task
    ? { kind: "edit", task, taskType: task.step == null ? "general" : "workflow" }
    : { kind: "create", taskType: isGeneralTask ? "general" : "workflow" };
